import { getBusinessRules } from '../countries/businessRules'

import type {
  CountryServiceRulesProfile,
  QueryCountryCode,
} from '@ngb-frontend/shared/types'

/** The country's fully-merged service rules, from the country registry */
export const getCountryServiceProfile = (
  countryCode?: QueryCountryCode,
): CountryServiceRulesProfile => getBusinessRules(countryCode).services
